import { IconButton, Typography } from '@material-ui/core';
import { createStyles, WithStyles, withStyles } from '@material-ui/core/styles';
import { Delete, Edit, Search } from '@material-ui/icons';
import * as React from 'react';
import { connect } from 'react-redux';
import axios from '../../axios-pod';
import SubheadingBar from '../../components/SubheadingBar/SubheadingBar';
import ConfirmationDialog from '../../components/UI/ConfirmationDialog/ConfirmationDialog';
import MainHeading from '../../components/UI/MainHeading/MainHeading';
import MainSection from '../../components/UI/MainSection/MainSection';
import MyDialog from '../../components/UI/MyDialog/MyDialog';
import MySnackbars from '../../components/UI/MySnackbars/MySnackbars';
import MyTable from '../../components/UI/MyTable/MyTable';
import MyTableLoader from '../../components/UI/MyTableLoader/MyTableLoader';
import SubHeading from '../../components/UI/SubHeading/SubHeading';
import SubSection from '../../components/UI/SubSection/SubSection';
import {
  IConfirmationDialogState,
  IFeed,
  IFilter,
  IFilterState,
  IScreen,
  IState,
  IUser
} from '../../models/states';
import { updateFilters } from '../../store/actions/filterActions';
import { fetchScreens } from '../../store/actions/screenActions';
import {
  addUser,
  deleteUser,
  updateUser
} from '../../store/actions/userActions';
import {
  ConfirmationTypes,
  initialConfirmationState,
  rowIndicators,
  UserRoles
} from '../../utilities/utilities';
import withErrorHandler from '../../utilities/withErrorHandler';
import UserForm from './UserForm/UserForm';

const styles = () =>
  createStyles({
    root: {},
    margin: {
      marginRight: '2rem',
      width: '25rem'
    },
    actionBtn: {
      display: 'flex',
      marginLeft: '-0.75rem'
    }
  });

class UserManagement extends React.Component<
  IUserManagementProps,
  IUserManagementState
> {
  constructor(props: IUserManagementProps) {
    super(props);
    this.state = {
      filters: {},
      searchText: '',
      isOpenUserForm: false,
      isEdit: false,
      currentUser: undefined,
      openSnackbar: false,
      variant: 'info',
      snackbarMessage: '',
      isOpenFilters: {
        screens: false
      },
      confirmationDialogProps: initialConfirmationState
    };
  }
  handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ searchText: event.target.value.toLowerCase() });
  };

  handleToggleHeaderFilters = (key: string) => {
    const updatedIsOpenFilter = { ...this.state.isOpenFilters };
    updatedIsOpenFilter[key] = !this.state.isOpenFilters[key];
    this.setState({ isOpenFilters: updatedIsOpenFilter });
  };

  getScreenName = (screenID: string): string | undefined => {
    const { screenMap: screens } = this.props;
    for (const i in screens) {
      if (screens[i].screenID === screenID) {
        return screens[i].name;
      }
    }
    return undefined;
  };

  createTableData = (usr: IUser[]): any[] => {
    let users = usr.slice();
    let result: any[] = [];
    const { classes, user, screenMap } = this.props;
    users = users.filter(u => {
      return u.role !== UserRoles.ADMIN && u.email !== user.email;
    });
    if (user && user.role !== UserRoles.ADMIN) {
      users = users.filter(u => {
        return u.screens.some(r => user.screens.indexOf(r) >= 0);
      });
    }

    result = users.map((row, index) => {
      return {
        dataKey: index,
        status: row.status === true ? 'Active' : 'Not Active',
        action: (
          <div className={classes.actionBtn}>
            <IconButton onClick={() => this.handleFormOpen(true, row)}>
              <Edit />
            </IconButton>
            <IconButton onClick={() => this.handleDeleteUser(row.userId)}>
              <Delete />
            </IconButton>
          </div>
        ),
        name: row.name,
        email: row.email,
        role: row.role,
        screens:
          row.screens.length === 0
            ? 'NA'
            : row.screens
                .map(screen =>
                  screenMap[screen] ? screenMap[screen].name : ''
                )
                .join(', '), // get Screen Name from code
        rowIndicator: row.status !== true ? rowIndicators.YELLOW : '',
        userId: row.userId
      };
    });
    return result;
  };

  handleFilterToggle = (filterName: string, filter: IFilter) => {
    this.props.updateFilters('users', filterName, filter);
  };

  handleSnackbarClose = (event: any, reason: any) => {
    if (reason === 'clickaway') {
      return;
    }
    this.setState({ openSnackbar: false });
  };
  handleFormClose = () => {
    this.setState({ isOpenUserForm: false });
  };
  handleFormOpen = (isEdit: boolean, user: IUser | undefined) => {
    this.setState({ isOpenUserForm: true, isEdit, currentUser: user });
  };
  handleSubmit = (user: IUser) => {
    if (this.state.isEdit) {
      // update the user
      this.props.updateUser(user);
    } else {
      this.props.addUser(user);
    }
    this.setState({ isOpenUserForm: false });
  };

  handleOpenNotification = (message: string, variant: string) => {
    this.setState({
      openSnackbar: true,
      variant,
      snackbarMessage: message
    });
  };
  renderDeleteUserContent = () => {
    return (
      <Typography>{`Are you sure you want to delete the user?`}?</Typography>
    );
  };
  handleDeleteUser = (userId: string) => {
    this.setState({
      confirmationDialogProps: {
        type: ConfirmationTypes.DELETE_USER,
        open: true,
        onProceedDialog: () => {
          this.props.deleteUser(userId);
          this.handleCloseConfirmationDialog();
        },
        onCloseDialog: this.handleCloseConfirmationDialog,
        content: this.renderDeleteUserContent(),
        title: 'Delete User'
      }
    });
  };
  handleCloseConfirmationDialog = () => {
    this.setState({ confirmationDialogProps: initialConfirmationState });
  };

  getFilteredData = () => {
    const { filters } = this.props;
    let users = [...this.props.users];
    // write separate filter for action

    Object.keys(filters.users).map(filterName => {
      const filterList = filters.users[filterName];
      const filterListWithSetLabel = filterList.filter(filter => filter.isSet);
      const filterListWithSetLabelList = filterListWithSetLabel.map(
        (filter: any) => {
          return filter.value;
        }
      );
      if (filterListWithSetLabel.length > 0) {
        users = users.filter((user: any) => {
          if (
            filterListWithSetLabelList.indexOf(user[filterName]) !== -1 ||
            (Array.isArray(user[filterName]) &&
              user[filterName].filter(
                (value: any) => -1 !== filterListWithSetLabelList.indexOf(value)
              ).length > 0)
          ) {
            return true;
          } else {
            return false;
          }
        });
      }
    });
    return users;
  };
  renderConfirmationDialog = () => {
    switch (this.state.confirmationDialogProps.type) {
      case ConfirmationTypes.DELETE_USER:
        return this.renderDeleteUserContent();
      default:
        return null;
    }
  };

  renderSubHeading = filteredData => {
    const totalItems = this.props.users.filter(u => u.role !== UserRoles.ADMIN)
      .length;
    return (
      <SubheadingBar
        title={'Users'}
        filteredItems={filteredData.length}
        filters={this.props.filters.users}
        toggleFilter={this.handleFilterToggle}
        totalItems={totalItems}
      />
    );
  };

  public render() {
    const { classes, user } = this.props;
    const data = this.getFilteredData();
    let filteredData = this.createTableData(data);
    const blur = globalThis.UI_CONFIG.blur_data;
    // todo: add last update in the users
    const userTableHeader = [
      {
        label: 'User',
        dataKey: 'name',
        isFilter: false,
        isSort: false,
        tooltip: true,
        lowercase: true
      },
      {
        label: 'Role',
        dataKey: 'role',
        isFilter: true,
        filters: this.props.filters.users.role,
        isSort: false,
        tooltip: true
      },
      {
        label: 'Email',
        dataKey: 'email',
        isFilter: false,
        isSort: true,
        tooltip: true,
        lowercase: true
      },
      {
        label: 'Screens',
        dataKey: 'screens',
        isFilter: true, // todo: change to true
        filters: this.props.filters.users.screens,
        tooltip: true,
        lowercase: true,
        blur
      },
      {
        label: 'Status',
        dataKey: 'status',
        isFilter: true, // change to true
        filters: this.props.filters.users.status,
        isSort: false
      }
    ];

    if (user && user.role === UserRoles.ADMIN) {
      userTableHeader.push({
        label: 'Action',
        dataKey: 'action',
        isFilter: false,
        filters: [],
        isSort: false
      });
    }

    const headerWrap: React.CSSProperties = {
      display: 'flex',
      justifyContent: 'space-between'
    };
    filteredData = filteredData.filter(d => {
      return (
        d.name.toLowerCase().indexOf(this.state.searchText) !== -1 ||
        d.email.toLowerCase().indexOf(this.state.searchText) !== -1 ||
        d.screens.toLowerCase().indexOf(this.state.searchText) !== -1
      );
    });
    return (
      <MainSection>
        <MainHeading
          showButton={user && user.role === UserRoles.ADMIN}
          mainHeading={'User Management'}
          buttonText={'Add User'}
          onSearch={this.handleSearch}
          onClickButton={() => this.handleFormOpen(false, undefined)}
          searchPlaceholder={'Search by User name/email ...'}
        />

        <SubSection>
          <SubHeading>{this.renderSubHeading(filteredData)}</SubHeading>
          {this.props.isFetching ? (
            <MyTableLoader />
          ) : (
            <MyTable
              tRows={filteredData}
              multiSelect={false}
              tHead={userTableHeader}
              order={'asc'}
              orderBy={'name'}
              isOpenFilters={this.state.isOpenFilters}
              onToggleHeaderFilters={this.handleToggleHeaderFilters}
              onToggleFilters={this.handleFilterToggle}
            />
          )}
          <MyDialog
            open={this.state.isOpenUserForm}
            onClose={this.handleFormClose}
            title={this.state.isEdit ? 'Edit User' : 'Add user'}
          >
            <UserForm
              user={this.state.currentUser}
              onSubmit={this.handleSubmit}
              screens={this.props.screenIds.map(screenId => {
                return {
                  label: this.props.screenMap[screenId].name,
                  value: screenId
                };
              })}
              users={this.props.users}
            />
          </MyDialog>
          <ConfirmationDialog {...this.state.confirmationDialogProps}>
            {this.renderConfirmationDialog()}
          </ConfirmationDialog>
          <MySnackbars
            open={this.state.openSnackbar}
            variant={this.state.variant}
            onClose={this.handleSnackbarClose}
            message={this.state.snackbarMessage}
          />
        </SubSection>
      </MainSection>
    );
  }
}
interface IUserManagementOwnProps extends WithStyles<typeof styles> {}
interface IUserManagementStateProps {
  users: IUser[];
  isAuthenticated: boolean;
  user: IUser;
  feedIds: string[]; // array to feed codes
  feedMap: { [key: string]: IFeed }; // feed code to feed mapping
  screenMap: { [key: string]: IScreen };
  screenIds: string[];
  filters: IFilterState;
  isFetching: boolean;
}
interface IUserManagementDispatchProps {
  fetchScreens: (userId: string) => any;
  deleteUser: (userId: string) => any;
  updateUser: (payload: any) => any;
  addUser: (payload: any) => any;
  updateFilters: (
    filterType: string,
    filterName: string,
    filter: IFilter
  ) => any;
}
type IUserManagementProps = IUserManagementOwnProps &
  IUserManagementStateProps &
  IUserManagementDispatchProps;

export interface IUserManagementState {
  filters: any;
  searchText: string;
  isOpenUserForm: boolean;
  isEdit: boolean;
  currentUser: IUser | undefined;
  openSnackbar: boolean;
  variant: string;
  snackbarMessage: string;
  isOpenFilters: {
    screens: boolean;
    [key: string]: any;
  };
  confirmationDialogProps: IConfirmationDialogState;
}

const mapStateToProps = (state: IState) => {
  return {
    users: state.user.users,
    user: state.user.userInfo,
    isAuthenticated: state.user.token.length !== 0,
    feedIds: state.feeds.feedIds,
    feedMap: state.feeds.feedMap,
    screenMap: state.screens.screenMap,
    screenIds: state.screens.screenIds,
    filters: state.filters,
    isFetching: state.user.isFetching
  };
};

const mapDispatchToProps: IUserManagementDispatchProps = {
  fetchScreens,
  deleteUser,
  addUser,
  updateUser,
  updateFilters
};

export default withStyles(styles)(
  connect<
    IUserManagementStateProps,
    IUserManagementDispatchProps,
    IUserManagementOwnProps
  >(
    mapStateToProps,
    mapDispatchToProps
  )(withErrorHandler(UserManagement, axios))
);
